'use client';

import React from 'react';

interface Props {
  shown: number;
  /** Size of the WHOLE listing, so the button's presence does not flicker while the top-up lands. */
  total: number;
  onLoadMore: () => void;
  /** True while the listing is still topping up — the button shows but cannot reveal missing hits. */
  disabled?: boolean;
}

/**
 * "Load More" button for the SSR grid. The first batch is rendered server-side and the rest arrives
 * with the dataset top-up; this reveals the next batch of it on the client. Rendered in the SSR HTML
 * (with the initial batch shown) and becomes interactive on hydration. Hidden once every tile is shown.
 */
const SsrLoadMore: React.FC<Props> = ({ shown, total, onLoadMore, disabled = false }) => {
  if (shown >= total) return null;

  return (
    <div className="mt-32 flex w-full justify-center">
      <button
        type="button"
        onClick={onLoadMore}
        disabled={disabled}
        aria-busy={disabled || undefined}
        className={`border border-[#090909] px-32 py-12 text-16 font-medium text-[#090909] transition-colors ${
          disabled ? 'cursor-default opacity-60' : 'cursor-pointer hover:bg-[#090909] hover:text-white'
        }`}
      >
        Load More
      </button>
    </div>
  );
};

export default SsrLoadMore;
